import PreviewPrint, { PreviewPrintProps } from "./PreviewPrint";

export { PreviewPrint, PreviewPrintProps };

export default PreviewPrint;
